import { render, staticRenderFns } from "./ButtonListRecipes.vue?vue&type=template&id=f930e312&"
import script from "./ButtonListRecipes.vue?vue&type=script&lang=js&"
export * from "./ButtonListRecipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports